import { Box } from "@mui/material";

import { ViewChangeButtonProps } from "./ViewChangeButton.types";

export function ViewChangeButton ({ onClick, Icon, sx }: ViewChangeButtonProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #D6D6DB",
        justifyContent: "center",
        width: "64px",
        height: "48px",
        ...sx,
      }}
      onClick={onClick}
    >
      <Icon fontSize="inherit" />
    </Box>
  );
}